export var AudioManager = {
  init: function() {
    $("#target_audio_save").click(async function(e){
      e.preventDefault();

      $("#upload_tab .errors").html("");
      if($("#target_audio_file").prop('files').length == 0 || $("#target_audio_description").val().length == 0 || $("#target_audio_type_id").val() == 'null') {
        $("#upload_tab .errors").append(`<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Please provide a name, type and audio file.
        </div>`);
        return;
      } 
      if($("input[name='audio_group']:checked").size()==0) {
        $("#upload_tab .errors").append(`<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Audio needs to be available to at least one group.
        </div>`);
        return;
      }

      panel_refresh($('#upload_tab'));
      const formData = new FormData()
      formData.append('audio_upload', '1')
      formData.append('audio_file', $("#target_audio_file").prop('files')[0])
      formData.append('audio_description', $("#target_audio_description").val())
      formData.append('target_audio_type_id', $("#target_audio_type_id").val())
      formData.append('domain_id', document.querySelector("#object_id").value);
      $("input[name='audio_group']:checked").each(function() {
        formData.append("group_id[]", this.value);
      });
      let domain_id = document.querySelector("#object_id").value
      await fetch('/admin/target_audio', {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        method: 'POST',
        body: formData
      });
      // Fetches specific audio types for select statements.
      data_binder = new DataBinder("/admin/domains/"+domain_id+"/target_audio/target_audio_type/"+$("#target_audio_type_id").val(), true);
      await data_binder.fetchData();
      AudioManager.clearForm();
      AudioManager.reloadData();
      panel_refresh($('#upload_tab'));
      $("#call_recording_tabs a[href='#list_tab']").click();
    });

    $("#callTreatmentsAudioModal").on("click", ".target_audio_delete", async function(e) {
      e.preventDefault();
      if(!confirm("Are you sure you want to delete this audio?")) {
        return false;
      }
      await fetch($(this).attr("href"), {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        method: 'DELETE'
      });
      AudioManager.reloadData();
      $("#call_recording_tabs a[href='#list_tab']").click();
    })

    $("#call_recording_tabs a[href='#upload_tab']").click(function() {
      AudioManager.clearForm();
    });

    $("#target_audio_cancel").click(function(e){
      e.preventDefault();
      AudioManager.clearForm();
      $("#call_recording_tabs a[href='#list_tab']").click();
    });

    $("#callTreatmentsAudioModal").on('change', '.btn-file :file', function() {
      var input = $(this),
          numFiles = input.get(0).files ? input.get(0).files.length : 1,
          label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
      input.trigger('fileselect', [numFiles, label]);
    });

    $("#callTreatmentsAudioModal").on('fileselect', '.btn-file :file', function(event, numFiles, label) {
          
          var input = $(this).parents('.input-group').find(':text'),
              log = numFiles > 1 ? numFiles + ' files selected' : label;
          
          if( input.length ) {
              input.val(log);
          } else {
              if( log ) alert(log);
          }
          
      });

    $("input[name='audio_group']").change(function(e){
      $("#selected_groups_size").html($("input[name='audio_group']:checked").size());
    });
  },
  clearForm: function() {
    $("#target_audio_description").val("");
    $("#target_audio_file").val("");
    $("#target_audio_file_text").val("")
    $("#target_audio_type_id").val("null");
  },
  reloadData: async function() {
    let domain_id = document.querySelector("#object_id").value
    
    // Fetches all data for the audio manager list.
    data_binder = new DataBinder("/admin/target_audio?domain_id="+domain_id, true);
    await data_binder.fetchData();
    AudioManager.renderTable();
  },
  renderTable: async function() {
    let domain_id = document.querySelector("#object_id").value
    data_binder = new DataBinder("/admin/target_audio?domain_id="+domain_id, true);
    await data_binder.fetchData();

    let data = data_binder.data;
    let audio_files = data.map(audio => `<tr><td>${audio.audio_desc}</td><td><audio-player src="${audio.audio_url}">
  </audio-player></td><td>${audio.target_audio_type.name}</td><td><i class="fa ${audio.is_used ? "fa-check" : "fa-times" }" aria-hidden="true"></i></td><td>${!audio.is_used ? `<a class="target_audio_delete" href="/admin/domains/<%= params[:id] %>/target_audio/${audio.target_audio_id}"><i class="fa fa-trash" aria-hidden="true"></i></a>`:``}</td></tr>`).join("")
  //   let audio_files = data.map(audio => `<tr><td>${audio.audio_desc}</td><td><audio style="height:20px;" controls>
  // <source src="${audio.audio_url}" type="audio/mpeg"></audio></td><td>${audio.target_audio_type.name}</td><td><i class="fa ${audio.is_used ? "fa-check" : "fa-times" }" aria-hidden="true"></i></td><td>${!audio.is_used ? `<a class="target_audio_delete" href="/admin/domains/<%= params[:id] %>/target_audio/${audio.target_audio_id}"><i class="fa fa-trash" aria-hidden="true"></i></a>`:``}</td></tr>`).join("")
    $("#callTreatmentsAudioModal table tbody").html(audio_files);  
    soundManager.reboot();
  }
}

class AudioSelect extends HTMLSelectElement {
  static get observedAttributes() { return ['default_option_text', 'no_change_option']; }
  attributeChangedCallback(name, ov, val) {
    switch (name) {
      case 'default_option_text':
        this.default_option_text = val;
      case 'no_change_option':
        this.no_change_option = val;
    }
  }
  constructor() {
    super();
    this.template = document.createElement('template');
    this.target_audio_type_id = this.getAttribute("target_audio_type");
    if(this.target_audio_type_id == null) {
      throw "Required attribute target_audio_type not set"
    }
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;
    let data_selected = this.getAttribute("data-selected");
    let data_selected_name = this.getAttribute("data-selected-name");
    
    if(data_selected != null && data_selected != "null" && data_selected != "no_change") {
      // It is possible that 
      let has_access_to_audio = false;
      this.data.forEach(( audio_option ) => {if(audio_option.target_audio_id == data_selected) has_access_to_audio = true} );

      if(!has_access_to_audio && data_selected_name != "null") {
        // Insert audio into options.
        this.data.unshift({target_audio_id: data_selected, audio_desc: data_selected_name})
      }
    }

    let first_option = `<option value='null'>${this.default_option_text != null ? this.default_option_text : "Choose"}</option>`;
    let no_change = `<option value='no_change'>No Change</option>`;
    let options = this.data.map(audio => audio.target_audio_id != null && audio.target_audio_id != 0 ? `<option value="${audio.target_audio_id}">${audio.audio_desc}</option>` : '').join("")
    this.template.innerHTML =`
    ${this.no_change_option == 'true' ? no_change : ''}
    ${first_option}
    ${options}
    `
    let value = this.value;
    if(value == "") {
      let data_selected = this.getAttribute("data-selected");
      value = data_selected;
    }
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    this.value = value;
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    let data_selected_domain = this.getAttribute("data-selected-domain");
    let domain_id = data_selected_domain || document.querySelector("#object_id").value;
    this.data_binder = new DataBinder("/admin/domains/"+domain_id+"/target_audio/target_audio_type/"+this.target_audio_type_id, true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('audio-select', AudioSelect, {extends: 'select'});

class AudioTypeSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;

    let options = this.data.map(audio => `<option value="${audio.target_audio_type_id}">${audio.name}</option>`).join("")
    this.template.innerHTML =`
    <option value=null>Choose</option>
    ${options}
    `
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    this.data_binder = new DataBinder("/admin/target_audio/target_audio_types", true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('audio-type-select', AudioTypeSelect, {extends: 'select'});